// extracted by mini-css-extract-plugin
export default {"Container":"Vita_Container__6sfX8","Vita":"Vita_Vita__FL306","h2":"Vita_h2__DHTok","scrolldownIndicator":"Vita_scrolldownIndicator__4d2cp","bounce":"Vita_bounce__xAbpL"};